/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UnreadCount = {
    properties: {
        name: {
    type: 'string',
    isRequired: true,
},
        count: {
    type: 'number',
    isRequired: true,
},
    },
};